// Checks if category equals or belongs to group
const belongsTo = (list, group, element) => {
  let current = element;

  while (true) {
    if (current == group) return true;

    const entry = list.find(cat => cat.id == current);
    if (!entry || entry.ancestry_depth === 1) return false;

    current = entry.parent_id;
  }
};

export default belongsTo;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/utils/belongsTo.js